import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { tabs } from 'calcite-web';

@Component({
    selector: 'om-draw-tool',
    templateUrl: './draw-tool.component.html',
    styleUrls: ['./draw-tool.component.css']
})
export class DrawToolComponent implements OnInit {
    @ViewChild('map', { static: true }) private readonly mapRef: ElementRef<any>;
    @ViewChild('pointTab', { static: true }) private readonly pointTab: ElementRef<any>;
    @ViewChild('lineTab', { static: true }) private readonly lineTab: ElementRef<any>;
    @ViewChild('polygonTab', { static: true }) private readonly polygonTab: ElementRef<any>;
    @ViewChild('textTab', { static: true }) private readonly textTab: ElementRef<any>;
    @ViewChild('buffer', { static: true }) private readonly buffer: any;

    activeTab: ElementRef<any>;
    defaultSymbolProperties: any = {
        point: {
            type: 'simple-marker',
            style: 'circle',
            color: 'red',
            size: '16px',
            outline: {
                color: 'yellow',
                width: 1
            }
        },
        line: {
            type: 'simple-line',
            style: 'solid',
            color: 'rgb(101, 135, 119)',
            width: 1,
            cap: 'round',
            join: 'round'
        },
        polygon: {
            type: 'simple-fill',
            color: 'rgb(101, 135, 119)',
            style: 'solid',
            outline: {
                color: 'black',
                style: 'solid',
                width: 1
            }
        },
        text: {
            type: 'text',
            color: 'black',
            horizontalAlignment: 'center',
            verticalAlignment: 'bottom',
            font: {
                size: '16px',
                family: 'Arial',
                weight: 'normal'
            }
        }
    };
    enableBuffer: boolean;
    bufferDrawing = false;
    bufferOptions: any = {
        showContinueButton: false
    };

    constructor(private readonly elementRef: ElementRef) { }

    ngOnInit() {
        tabs();
        this.initializeTabs();
    }

    initializeTabs() {
        this.pointTab.nativeElement.symbolProperties = this.defaultSymbolProperties.point;
        this.lineTab.nativeElement.symbolProperties = this.defaultSymbolProperties.line;
        this.polygonTab.nativeElement.symbolProperties = this.defaultSymbolProperties.polygon;
        this.textTab.nativeElement.symbolProperties = this.defaultSymbolProperties.text;
    }

    activateTabByName(name: string) {
        if (this.activeTab) {
            this.activeTab.nativeElement.enabled = false;
        }

        switch (name) {
            case 'point':
                this.pointTab.nativeElement.enabled = true;
                this.activeTab = this.pointTab;
                this.enableBuffer = true;
                break;

            case 'line':
                this.lineTab.nativeElement.enabled = true;
                this.activeTab = this.lineTab;
                this.enableBuffer = true;
                break;

            case 'polygon':
                this.polygonTab.nativeElement.enabled = true;
                this.activeTab = this.polygonTab;
                this.enableBuffer = true;
                break;

            case 'text':
                this.textTab.nativeElement.enabled = true;
                this.activeTab = this.textTab;
                this.enableBuffer = false;
                break;

            default:
                this.activeTab.nativeElement.enabled = true;
                break;
        }
    }

    onOpen() {
        if (this.activeTab) {
            this.activeTab.nativeElement.enabled = true;
        } else {
            this.activateTabByName('point');
            this.elementRef.nativeElement.querySelector('#point-tab-title').classList.add('is-active');
            this.enableBuffer = true;
        }
    }

    onClose() {
        if (this.activeTab && this.activeTab.nativeElement) {
            this.activeTab.nativeElement.enabled = false;
        }
    }

    onDrawComplete(event) {
        if (this.bufferDrawing && this.enableBuffer && event.detail && event.detail.geometry) {
            this.buffer.nativeElement.geometry = event.detail.geometry;
            this.buffer.nativeElement.createBuffer();
        }
    }
}
